import { Socket } from "socket.io-client";
import { boolean } from "yup";
import { create } from "zustand";

interface socketStoreInterface {
    socketObj: Socket | null,
    setSocketObj: (value: Socket | null) => void,

    socketReconnectAttempts: number, 
    setSocketReconnectAttempts: (value: number) => void,

    reconnectTimer: NodeJS.Timeout | null,
    setReconnectTimer: (value: NodeJS.Timeout | null) => void,

    pingInterval: NodeJS.Timeout | null,
    setPingInterval: (value: NodeJS.Timeout | null) => void,

    socketReconnectDelays: number[],

    flagExplicitSocketDisconnect: boolean, 
    setFlagExplicitSocketDisconnect: (value: boolean) => void,

    socketConnectionAccessToken: string, 
    setSocketConnectionAccessToken: (value: string) => void,

    flagShowSocketConnectionLossPopup: boolean,
    setFlagShowSocketConnectionLossPopup: (value: boolean) => void,

    maxReconnectAttemptsReached: boolean,
    setMaxReconnectAttemptsReached: (value: boolean) => void,

    lastConnectionTimestamp: number | null,
    setLastConnectionTimestamp: (value: number | null) => void,

    socketServerUrl: string | null,
    setSocketServerUrl: (value: string | null) => void,
}

export const useSocketStore = create<socketStoreInterface>((set) => ({
    socketObj: null,
    setSocketObj: (value: Socket | null) => set({ socketObj: value }),

    socketReconnectAttempts: 0,
    setSocketReconnectAttempts: (value: number) => set({ socketReconnectAttempts: value }),

    reconnectTimer: null,
    setReconnectTimer: (value: NodeJS.Timeout | null) => set({ reconnectTimer: value }),

    pingInterval: null,
    setPingInterval: (value: NodeJS.Timeout | null) => set({ pingInterval: value }),

    socketReconnectDelays: [0, 15000, 30000, 60000],

    flagExplicitSocketDisconnect: false,
    setFlagExplicitSocketDisconnect: (value: boolean) => set({ flagExplicitSocketDisconnect: value }),

    socketConnectionAccessToken: "",
    setSocketConnectionAccessToken: (value: string) => set({ socketConnectionAccessToken: value }),

    flagShowSocketConnectionLossPopup: false,
    setFlagShowSocketConnectionLossPopup: (value: boolean) => set({ flagShowSocketConnectionLossPopup: value }),

    maxReconnectAttemptsReached: false,
    setMaxReconnectAttemptsReached: (value: boolean) => set({ maxReconnectAttemptsReached: value }),

    lastConnectionTimestamp: null,
    setLastConnectionTimestamp: (value: number | null) => set({ lastConnectionTimestamp: value }),

    socketServerUrl: null,
    setSocketServerUrl: (value: string | null) => set({ socketServerUrl: value }),

}))